import React from 'react';
import { PEER_REVIEW_PAGE_SIZE_OPTIONS } from '../../constants/peerReviewColumns';

export type PeerReviewPaginationProps = {
  selectedCount: number;
  totalItems: number;
  currentPage: number;
  perPage: number;
  onChangePage: (page: number) => void;
  onChangePerPage: (perPage: number) => void;
};

export default function PeerReviewPagination({
  selectedCount,
  totalItems,
  currentPage,
  perPage,
  onChangePage,
  onChangePerPage,
}: Readonly<PeerReviewPaginationProps>) {
  const totalPages = Math.max(1, Math.ceil(totalItems / perPage) || 1);

  return (
    <div className="peer-review-pagination">
      <p className="peer-review-pagination__selection">
        {selectedCount} of {totalItems} row(s) selected.
      </p>
      <div className="peer-review-pagination__right">
        <label className="peer-review-pagination__per-page">
          <span>Rows per page</span>
          <select
            value={perPage}
            aria-label="Rows per page"
            onChange={event => onChangePerPage(Number(event.target.value))}
          >
            {PEER_REVIEW_PAGE_SIZE_OPTIONS.map(size => (
              <option
                key={size}
                value={size}
              >
                {size}
              </option>
            ))}
          </select>
        </label>
        <span className="peer-review-pagination__page-label">
          Page {currentPage} of {totalPages}
        </span>
        <div className="peer-review-pagination__nav">
          <button
            type="button"
            disabled={currentPage <= 1}
            onClick={() => onChangePage(currentPage - 1)}
          >
            Previous
          </button>
          <button
            type="button"
            disabled={currentPage >= totalPages}
            onClick={() => onChangePage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
